export const SOCKET_MESSAGE_TYPE = {
  CHECK_CONNECTION_STATUS: "CHECK_CONNECTION_STATUS",
  CONNECTION_STATUS: "CONNECTION_STATUS",
  CONNECT: "CONNECT",
  CONNECTED: "CONNECTED",
  CONNECT_FAILURE: "CONNECT_FAILURE",
  DISCONNECT: "DISCONNECT",
  INITIALIZE_DEVICE: "INITIALIZE_DEVICE",
  DEVICE_ARCHIVED: "DEVICE_ARCHIVED",
  STORE_ARCHIVED: "STORE_ARCHIVED",
  RELEASE_NOTIFICATION: "RELEASE_NOTIFICATION",
  INITIALIZATION_COMPLETED: "initializationCompleted",
  CHECKOUT_CONFIRMATION: "CHECKOUT_CONFIRMATION",
  RECONNECT: "RECONNECT",
};

export const WS_RECONNECT_LOG_MILESTONES = [
  100, 250, 500, 750, 1000, 1250, 1500, 1750, 2000,
];

export const MESSAGE_TARGET = {
  INITIALIZE_DEVICE: "initializeDevice",
  DEVICE_ARCHIVED: "deviceArchived",
  STORE_ARCHIVED: "storeArchived",
  RELEASE_NOTIFICATION: "releaseNotification",
  INITIALIZATION_COMPLETED: "initializationCompleted",
  CHECKOUT_CONFIRMATION: "checkoutConfirmation",
};

export const WS_CONNECTION_ATTEMPTS_BEFORE_DELAY_CHANGE = 3;
export const INITIAL_RETRY_CONNECTION_DELAY = 3000;
export const RETRY_CONNECTION_DELAY = 60 * 1000;
